import { fetchApi } from '@/services/api-client';

export const ANNOUNCEMENTS_PATH = '/admin/announcements';

export type AnnouncementType = 'urgent' | 'info';

export type Announcement = {
  id: string;
  message: string;
  type: AnnouncementType;
  linkUrl: string | null;
  linkLabel: string | null;
  active: boolean;
  startAt: string | null;
  endAt: string | null;
};

export type CreateAnnouncementData = {
  message: string;
  type?: AnnouncementType;
  linkUrl?: string | null;
  linkLabel?: string | null;
  startAt?: string | null;
  endAt?: string | null;
};

export type UpdateAnnouncementData = Partial<CreateAnnouncementData>;

export const announcementsApi = {
  getAll: () => fetchApi<Announcement[]>(ANNOUNCEMENTS_PATH),
  getById: (id: string) => fetchApi<Announcement>(`${ANNOUNCEMENTS_PATH}/${id}`),
  create: (data: CreateAnnouncementData) =>
    fetchApi<Announcement>(ANNOUNCEMENTS_PATH, { method: 'POST', body: JSON.stringify(data) }),
  update: (id: string, data: UpdateAnnouncementData) =>
    fetchApi<Announcement>(`${ANNOUNCEMENTS_PATH}/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  activate: (id: string) => fetchApi<Announcement>(`${ANNOUNCEMENTS_PATH}/${id}/activate`, { method: 'PATCH' }),
  deactivate: (id: string) => fetchApi<Announcement>(`${ANNOUNCEMENTS_PATH}/${id}/deactivate`, { method: 'PATCH' }),
  delete: (id: string) => fetchApi<{ success: boolean }>(`${ANNOUNCEMENTS_PATH}/${id}`, { method: 'DELETE' }),
};
